<template>
  <v-row>
    <v-col cols="12" style="position: relative;">
      <v-card>
        <v-btn
          absolute
          dark
          fab
          top
          right
          small
          color="error"
          @click="cancel"
        >
          <v-icon small>mdi-close</v-icon>
        </v-btn>

        <div v-if="loading" class="text-center pa-6">
          <v-progress-circular
            :size="40"
            :width="7"
            color="primary"
            indeterminate
          ></v-progress-circular>
        </div>

        <v-card-text v-else>
          <v-form v-model="form.valid" ref="form" :disabled="form.disabled" lazy-validation>
            <v-text-field
              label="Title"
              v-model="form.data.title"
              :rules="form.rules.title"
              outlined
            />
            <v-textarea
              label="Description"
              v-model="form.data.description"
              outlined
            ></v-textarea>
            <v-checkbox
              v-model="form.data.is_active"
              label="Active"
            ></v-checkbox>

            <v-btn v-if="folderId" color="error" class="mr-4" :disabled="!form.valid" v-text="'Delete'" @click="remove"></v-btn>
            <v-btn color="primary" class="mr-4" :disabled="!form.valid" v-text="'Save changes'" @click="save"></v-btn>
            <v-btn color="primary" outlined :disabled="!form.valid" v-text="'Cancel'" @click="cancel"></v-btn>
          </v-form>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { getFolderById, createFolder, updateFolder, deleteFolder } from './api';

export default {
  name: 'JumpStartFolderEdit',
  data: () => ({
    loading: false,
    folderId: null,
    parentId: null,
    form: {
      disabled: false,
      valid: true,
      data: {
        title: '',
        description: '',
        is_active: true,
      },
      rules: {
        title: [v => !!v || 'Title is required!'],
        description: [],
      },
    },
  }),
  mounted () {
    this.parentId = this.$route.query.parentId;
    this.folderId = this.$route.params.id
      ? parseInt(this.$route.params.id, 10)
      : null;

    if (this.folderId) {
      this.get();
    }
  },
  methods: {
    save() {
      if (!this.$refs.form.validate()) {
        return;
      }

      if (this.folderId) {
        this.update();
      } else {
        this.create();
      }
    },
    get() {
      this.loading = true;

      getFolderById(this.folderId)
        .then((folder) => (this.form.data = { ...this.form.data, ...folder}))
        .finally(() => (this.loading = false));
    },
    update() {
      this.loading = true;

      updateFolder(this.folderId, this.form.data)
        .then(() => this.cancel())
        .finally(() => (this.loading = false));
    },
    create() {
      this.loading = true;

      createFolder({ ...this.form.data, parent_id: this.parentId })
        .then(() => this.cancel())
        .finally(() => (this.loading = false));
    },
    remove() {
      const text = {
        title: `Delete folder`,
        text: `You are about to delete folder «${this.form.data.title}». Are you sure to proceed?`,
      };

      this.$swal.fire(text.title, text.text)
        .then(({ isConfirmed }) => isConfirmed ? this.delete() : Promise.resolve());
    },
    delete() {
      this.loading = true;

      return deleteFolder(this.folderId).then(() => this.cancel())      
    },
    cancel() {
      this.$router.push({
        name: 'system-admin-jump-start',
        query: { folderId: this.parentId },
      });
    },
  }
}
</script>

<style>

</style>